import React, { useEffect, useState, useRef, useContext } from "react";
import { assetUrl } from "../Utils/assetUrl";
import Navbar from "./Navbar.Component/navbar";
import Body from "./body.component/body.component";
import ProjectContext from "../context/ProjectContext";
import Leftbar from "../dashboard.component/dashboard.leftbar.component/dashboard.leftbar.component";
import "../css/style.scss";
import AuthContext from "../context/userAuth.context";
import Timer from "../Utils/Timer";
import axios from "axios";
import "../css/dashboard.scss";
import DLoader from "../assets/Loader/mainLoader.json";
import Lottie from "lottie-web";
import Preview from "./previewpop/preview";
import AdminProps from "../Administration/AdminProps";
import MyContext from "../context/MyContext";
import DefaultCharacterView from "../SmartCharacterBuilder/DefaultCharacterView";
import swal from "sweetalert";
import AIContent from "../AI/AIContent";
import { ElevatorSharp } from "@mui/icons-material";
import LinkGenerator from "../Link/LinkGenerator";
import { startExport } from "../Utils/exportApi";
import { loadLottieJson } from "../Utils/lottieCache";
import { parseProjectData, packExportLayers } from "../Utils/projectPack";
import { linkEmbeddedImages } from "../Utils/layerImages";
import { getSlideTransition, getSlideTransitionNow, preloadSlideTransitions, secondsToTimeString } from "../Utils/slideTransitions";

const clone = (obj) => {
  var copy;
  if (null === obj || "object" != typeof obj) return obj;
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
    }
    return copy;
  }
  throw new Error("Unable to copy obj! Its type isn't supported.");
};

const Editor = () => {
  const [projectEditorZoom, setprojectEditorZoom] = useState(100);

  var _unloadedCounter = -2;

  const [Clear, setClear] = useState(false);

  const [changes, setchanges] = useState(true);

  const AnimationRef = useRef(null);

  const [LoadCounter, setLoadCounter] = useState([]);

  const [UnloadedCounter, setUnloadedCounter] = useState(-2);

  const {
    onePxEquivalent,
    EditorZoom,
    CanvasDisplay,
    setisTextInputOrAreaFocus,
  } = useContext(MyContext);
  const [title, setTitle] = useState(null);
  const [article, setArticle] = useState(null);

  const {
    authenticationData,
    setAuthenticationData,
    apiBaseurl,
    ExpiryCountdown,
    setExpiryCountdown,
    setUserData,
    setAllProject,
    Role,
  } = useContext(AuthContext);

  const [changinCanvasSize, setchanginCanvasSize] = useState(false);
  const [CurrentProject, setCurrentProject] = useState(null);

  const [watermark, setwatermark] = useState({
    added: false,
    src: "",
    position: "Top Left",
    opacity: 100,
    enabled: true,
    pattern: "",
  });
  const [bgmusicState, setbgmusicState] = useState({
    added: false,
    src: "",
    volume: 100,
    name: "",
    duration: "",
  });
  function loadImage(path) {
    return new Promise(async (resolve, reject) => {
      if (!path.includes(".svg")) {
        let imSrc = path;
        if (
          !path.includes("data:image/png;base64") &&
          !path.includes("data:image/jpeg;base64")
        ) {
          imSrc = await getImageSrc(path);
        }
        resolve(imSrc);
        // let img = new Image();
        // img.onload = function () {
        //   resolve(img);
        // };
        // img.src = imSrc;
      } else if (path.includes(".svg")) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
        axios
          .get(
            authenticationData.ApiBaseURL + "/api/Asset/getAsset?path=" + path,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            resolve(response.data);

            // console.log(response.data);
            // let img = new Image();
            // img.onload = function () {
            //   resolve(img);
            // };
            // img.src = response.data;
          });
      }
    });
  }
  function getImageSrc(url) {
    // Falls back to the plain URL if the conversion fails, instead of waiting forever.
    return ImageURLToBase64(url).catch(() => url);
  }
  const ImageURLToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      var splittedURL = url.split("/");
      var imageName = splittedURL[splittedURL.length - 1];
      var extension = imageName.split(".")[1];

      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Images/ImageURLToBase64?url=" +
            url,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data != null && response.data != "") {
            var format = "data:image/jpeg;base64,";
            if (extension.toLowerCase() === "png") {
              format = "data:image/png;base64,";
            }
            var baseStr = format + response.data;

            resolve(baseStr);
          } else {
            reject(new Error("Image could not be converted: " + url));
          }
        })
        .catch((error) => {
          console.log(error);
          reject(error instanceof Error ? error : new Error("Image could not be converted: " + url));
        });
    });
  };
  function loadCharacter(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        resolve(xml);
        //resolve(div);
      } catch (error) {}
    });
  }
  function loadBasicShape(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        var svg64 = btoa(xml);
        var b64Start = "data:image/svg+xml;base64,";
        var image64 = b64Start + svg64;
        resolve(image64);
      } catch (error) {}
    });
  }
  const calculateTimeByWidth = (width) => {
    let ms = parseFloat(
      (width * localStorage.getItem("onePxEquivalent")).toFixed(3)
    );
    return msToTime(ms);
  };

  const msToTime = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    return (
      pad(hrs) +
      ":" +
      pad(mins) +
      ":" +
      pad(secs) +
      ":" +
      pad(Math.round(ms), 3)
    );
  };

  useEffect(() => {
    // debugger

    //Doing this if changing canvas size inside editor... so we ignore resetting project settings..
    if (changinCanvasSize) {
      return;
    }

    if (CurrentProject) {
      if (
        CurrentProject.projectData != null &&
        CurrentProject.projectData != ""
      ) {
        let recivedData = parseProjectData(CurrentProject.projectData); //if layer data is parsed sepratly we should have to parse it manualyy here to use it
        var array = Array.from(recivedData);
        for (let i = 0; i < array.length; i++) {
          if (i === 0) {
            array[i].IsActive = true;
          } else {
            array[i].IsActive = false;
          }
        }
        if (
          array[0].canvasHeight == undefined &&
          array[0].canvasWidth == undefined
        ) {
          let Data = array.map((obj) => ({
            ...obj,
            canvasWidth: null,
            canvasHeight: null,
          }));
          setslides(Data);
        } else {
          setslides(array);
        }
      } else {
        let obj = [
          {
            key: 0,
            LayerData: [],
            IsActive: true,
            SlideBackground: {
              type: "",
              color: null,
              Path: null,
              gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
            },
            canvasWidth: null,
            canvasHeight: null,
            TotalLength: "00:00:10:00",
            SlideImage: null,
            SmallTime: "10.0 s",
          },
        ];
        setslides(obj);
      }
      setProjectLoaded(false);
      setDeafultLoader({ played: false, stat: false });
    } else {
      if (sessionStorage.getItem("myProjectData")) {
        loadMyProject();
      } else if (sessionStorage.getItem("CurrentChooseProjectId")) {
        loadTemplate();
      } else if (sessionStorage.getItem("createNewProject")) {
        CreateProject();
      }
    }
  }, [CurrentProject]);

  const loadTemplate = () => {
    let currentID = sessionStorage.getItem("CurrentChooseProjectId");
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Project/UserTemplate?id=" +
          currentID,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then(async (response) => {
        // if (response.data == "") {
        //   CreateProject();
        // }
        if (response.data.result == "") {
          CreateProject();
        }
        // Old and new (packed) saved formats both come back as the usual slide array.
        let projData = parseProjectData(response.data.result.projectData);

        if (
          response.data.result.watermark &&
          response.data.result.watermark != "null"
        ) {
          setwatermark(JSON.parse(response.data.result.watermark));
        }
        if (
          response.data.result.backgroundMusic &&
          response.data.result.backgroundMusic != "null"
        ) {
          setbgmusicState(JSON.parse(response.data.result.backgroundMusic));
        }

        // for (let i = 0; i < projData.length; i++) {
        //   for (let j = 0; j < projData[i].LayerData.length; j++) {
        //     if (
        //       projData[i].LayerData[j].type == "text" &&
        //       !projData[i].LayerData[j].googleFontSetting
        //     ) {
        //       projData[i].LayerData[j].googleFontSetting = {
        //         fontName: "Roboto",
        //         fontFamily: "'Roboto', sans-serif",
        //         googleFontUrl:
        //           "https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap",
        //       };
        //     }

        //     if (projData[i].LayerData[j].type == "Character" && !projData[i].LayerData[j].JSONValue) {
        //       const resp = await fetch(
        //         assetUrl(authenticationData.ApiBaseURL, projData[i].LayerData[j].character_FilePath)
        //       );
        //       let json = await resp.json();
        //       if (projData[i].LayerData[j].ColorSettings && projData[i].LayerData[j].ColorSettings.filter(x => x.part == "Shirt")[0].rgba != "") {
        //         await setShirtColor(json, projData[i].LayerData[j].ColorSettings.filter(x => x.part == "Shirt")[0].rgba);
        //       }
        //       if (projData[i].LayerData[j].ColorSettings && projData[i].LayerData[j].ColorSettings.filter(x => x.part == "Skin")[0].rgba != "") {
        //         await setSkinColor(json, projData[i].LayerData[j].ColorSettings.filter(x => x.part == "Skin")[0].rgba);
        //       }
        //       projData[i].LayerData[j].JSONValue = json;
        //     }

        //   }
        // }
        response.data.result.projectData = JSON.stringify(projData);
        // localStorage.removeItem('CurrentChooseProject')
        // localStorage.setItem('CurrentChooseProject', JSON.stringify(response.data.result));
        //setCurrentProject(JSON.parse(localStorage.getItem("CurrentChooseProject")))
        sessionStorage.setItem(
          "CurrentChooseProjectId",
          response.data.result.id
        );

        if (!response.data.result.isSaved) setchanges(false);

        setCurrentProject(response.data.result);
        //setLayersData(projData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setSkinColor = async (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Face") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "EyeShut") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "EyeShut1") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "EyeShut2") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "Body") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "Hand_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "Hand_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Neck") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Ear") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Ear_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Ear_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Calf_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Calf_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Leg_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Leg_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Shoe_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Shoe_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setShirtColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }

          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const loadMyProject = () => {
    // debugger
    let params = JSON.parse(sessionStorage.getItem("myProjectData"));
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Project/GetMyProject?id=" +
          params.id,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then(async (response) => {
        if (response.data.result != null && response.data.result[0]) {
          // Old and new (packed) saved formats both come back as the usual slide array.
          let projData = parseProjectData(response.data.result[0].projectData);
          if (
            response.data.result[0].watermark &&
            response.data.result[0].watermark != "null"
          ) {
            setwatermark(JSON.parse(response.data.result[0].watermark));
          }
          if (
            response.data.result[0].backgroundMusic &&
            response.data.result[0].backgroundMusic != "null"
          ) {
            setbgmusicState(
              JSON.parse(response.data.result[0].backgroundMusic)
            );
          }

          for (let i = 0; i < projData.length; i++) {
            for (let j = 0; j < projData[i].LayerData.length; j++) {
              if (
                projData[i].LayerData[j].type == "text" &&
                !projData[i].LayerData[j].googleFontSetting
              ) {
                projData[i].LayerData[j].googleFontSetting = {
                  fontName: "Roboto",
                  fontFamily: "'Roboto', sans-serif",
                  googleFontUrl:
                    "https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap",
                };
              }

            }
          }

          // Characters without their animation data: load them all at the same time (each file
          // only once) instead of one after another. One missing file no longer stops the
          // whole project from opening.
          const missing = [];
          for (let i = 0; i < projData.length; i++) {
            for (let j = 0; j < projData[i].LayerData.length; j++) {
              const layer = projData[i].LayerData[j];
              if (layer.type == "Character" && !layer.JSONValue && layer.character_FilePath) {
                missing.push(layer);
              }
            }
          }
          await Promise.all(
            missing.map((layer) =>
              loadLottieJson(authenticationData.ApiBaseURL, layer.character_FilePath)
                .then((json) => {
                  layer.JSONValue = json;
                })
                .catch((e) => console.log("Could not load character", layer.character_FilePath, e))
            )
          );
          params.projectData = JSON.stringify(projData); //response.data.result[0];
          params.isSaved = response.data.result[0].isSaved;
          setCurrentProject(params);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const CreateProject = () => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    let str = sessionStorage.getItem("ProjectAspectRatio");
    if (Role == "admin") {
      fetch(
        authenticationData.ApiBaseURL +
          "/api/Template/CreateTemplateData?body=" +
          str,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data != null) {
            if (data.result) {
              setAllProject(data.result);
            } else {
              setAllProject([]);
            }
            setCurrentProject(data.currentItem);
            //localStorage.setItem('CurrentChooseProject', JSON.stringify(data.currentItem));
            //history.push('./editor')
          }
        })
        .catch((error) => {});
    } else {
      fetch(
        authenticationData.ApiBaseURL + "/api/Project/StartProject?body=" + str,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data != null) {
            if (!data.currentItem.isSaved) setchanges(false);

            sessionStorage.setItem(
              "CurrentChooseProjectId",
              data.currentItem.id
            );
            setAllProject(data.result);
            setCurrentProject(data.currentItem);
            //localStorage.setItem('CurrentChooseProject', JSON.stringify(data.currentItem));
            //history.push('./editor')
          }
        })
        .catch((error) => {});
    }
  };

  const [slides, setslides] = useState();

  const [DashPop, setDashPop] = useState(false);

  const [AdminPanelPopup, setAdminPanelPopup] = useState(false);
  const [AIContentPopup, setAIContentPopup] = useState(false);
  const [linkGenPop, setLinkGenPop] = useState(false);

  const [ShowSmartCharaterBuilderPanel, setShowSmartCharaterBuilderPanel] =
    useState(false);
  const [ProjectLoaded, setProjectLoaded] = useState(false);

  const [ChangeCount, setChangeCount] = useState(0);

  const [DeafultLoader, setDeafultLoader] = useState({
    played: true,
    stat: true,
    Message: "",
  });

  useEffect(() => {
    if (DeafultLoader.stat) {
      Lottie.loadAnimation({
        container: AnimationRef.current,
        name: "DefaultLoader",
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: DLoader,
      });
    } else {
      if (DeafultLoader.played) {
        Lottie.destroy("DefaultLoader");
      }
    }
  }, [DeafultLoader]);

  const [LayersData, setLayersData] = useState([]);
  const [SlidesData, setSlidesData] = useState([]);
  const [charstate, setcharstate] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [slide_background_image, setSlide_background_image] = useState("");
  var TotalSlideTimeForTransition = 0;
  const [SupremeLayer, setSupremeLayer] = useState({
    TotalTime: "",
    Layer: "",
  });

  const [PopupWidthHeight, setPopupWidthHeight] = useState({
    width: 1000,
    height: 500,
  });

  const [popupload, setpopupload] = useState(null);
  const [CallForExport, setCallForExport] = useState({
    status: false,
    fps: 30,
    format: "mp4",
  });

  const [ScreenSize, setScreenSize] = useState("small");

  const [SlideBackground, setSlideBackground] = useState([]);

  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const calculateWidthByDuration = (duration) => {
    var onePxEquivalent = 8.620689655172415;
    // var onePxEquivalent = 5000 / 4 / 29;
    var tempArr = duration.split(":");
    var hours = parseInt(tempArr[0]);
    var minutes = parseInt(tempArr[1]);
    var seconds = parseInt(tempArr[2]);
    var milliseconds = parseInt(tempArr[3]);
    var totalMilliseconds =
      (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;
    return Math.round(totalMilliseconds / onePxEquivalent); //onePxEquivalent
  };
  const calculateWidthByDurationRelative = (duration) => {
    var onePxEquivalent = 0;
    if (window.localStorage.getItem("onePxEquivalent")) {
      onePxEquivalent = window.localStorage.getItem("onePxEquivalent");
    } else {
      onePxEquivalent = 5000 / 4 / 29;
    }

    var tempArr = duration.split(":");
    var hours = parseInt(tempArr[0]);
    var minutes = parseInt(tempArr[1]);
    var seconds = parseInt(tempArr[2]);
    var milliseconds = parseInt(tempArr[3]);
    var totalMilliseconds =
      (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;
    return Math.round(totalMilliseconds / onePxEquivalent); //onePxEquivalent
  };

  const getSlideTtransition1 = (
    type,
    name,
    key,
    _duration,
    filename,
    fromExport = false
  ) => {
    let newEntryLayerData = {
      AnimationId: makeid(7),
      key: key,
      type: "SlideTransition", //"Character",
      bgColor: "#00adff",
      Name: `Slide-Transition-${name}`,
      canvas: null,
      userFile: "xyz",
      transition: 1,
      layerIndex: 1,
      index: null,
      TimelineZoom: 6, //timelineZoomVal,
      duration: _duration, //totalTime,
      startTime: "00:00:00:009", //currentTime,
      endTime: _duration, //calculateTimeByWidth(Tl_TotalTime.width),
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      typeIcon: "person",
      character_poses: [], //props.obj.poses,
      ImageSrc: "",

      //character_FilePath: authenticationData.ApiBaseURL + '/Assets/SlideTransitions/lf20_jlj5m1il.json', //with out .json

      // character_FilePath: fromExport
      //   ? "/Assets/SlideTransitions/" + filename
      //   : authenticationData.ApiBaseURL +
      //   "/Assets/SlideTransitions/" +
      //   filename,
      character_FilePath:
        fromExport && CurrentProject.canvasSize === "16:9"
          ? "/Assets/SlideTransitions/" + filename
          : fromExport && CurrentProject.canvasSize === "1:1"
          ? "/Assets/SlideTransitions/square/" + filename
          : fromExport && CurrentProject.canvasSize === "9:16"
          ? "/Assets/SlideTransitions/potrait/" + filename
          : !fromExport && CurrentProject.canvasSize === "16:9"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/" +
            filename
          : !fromExport && CurrentProject.canvasSize === "1:1"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/square/" +
            filename
          : !fromExport && CurrentProject.canvasSize === "9:16"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/potrait/" +
            filename
          : authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/" +
            filename,
      //: authenticationData.ApiBaseURL + "/Assets/SlideTransitions/square/" + filename,

      //with out .json
      //character_FilePath: authenticationData.ApiBaseURL + '/Assets/SlideTransitions/2.json', //with out .json
      //character_FilePath: "https://assets1.lottiefiles.com/packages/lf20_y29qdwhx.json",
      //character_FilePath: "https://assets1.lottiefiles.com/packages/lf20_7ti3aixq.json",
      // character_FilePath: "https://assets1.lottiefiles.com/packages/lf20_p1yzsk52.json",
      //character_FilePath: "https://assets1.lottiefiles.com/packages/lf20_scgoh91m.json",
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      x: 0,
      y: 0,
      opacity: 1,
      width: PopupWidthHeight.width,
      height: PopupWidthHeight.height,
      toolbar: false,
      FurtherSetting: false,
      lock: false,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      CharacterStop: true,
      CharacterPause: false,
      CharacterPlayed: false,
      startPositionOnTimeline: 160, //TickerPosition,
      player: false,
      Animate: false,
      flip: "scaleX(1)",
      rotateAngle: 0,
      AzData: null,
      reverse: false,
    };
    newEntryLayerData.widthOnTimeline = calculateWidthByDurationRelative(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    return newEntryLayerData;
  };

  const getSlideTtransition2 = (
    type,
    name,
    key,
    _duration,
    filename,
    fromExport = false
  ) => {
    let newEntryLayerData = {
      AnimationId: makeid(7),
      key: key,
      type: "SlideTransition", //"Character",
      bgColor: "#00adff",
      Name: `Slide-Transition-${name}`,
      canvas: null,
      userFile: "xyz",
      transition: 2,
      layerIndex: 1,
      index: null,
      TimelineZoom: 6, //timelineZoomVal,
      duration: _duration, //totalTime,
      startTime: "00:00:00:009", //currentTime,
      endTime: _duration, //calculateTimeByWidth(Tl_TotalTime.width),
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      typeIcon: "person",
      character_poses: [], //props.obj.poses,
      ImageSrc: "",
      //character_FilePath: authenticationData.ApiBaseURL + '/Assets/SlideTransitions/Transition1_2.json',

      character_FilePath:
        fromExport && CurrentProject.canvasSize === "16:9"
          ? "/Assets/SlideTransitions/" + filename
          : fromExport && CurrentProject.canvasSize === "1:1"
          ? "/Assets/SlideTransitions/square/" + filename
          : fromExport && CurrentProject.canvasSize === "9:16"
          ? "/Assets/SlideTransitions/potrait/" + filename
          : !fromExport && CurrentProject.canvasSize === "16:9"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/" +
            filename
          : !fromExport && CurrentProject.canvasSize === "1:1"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/square/" +
            filename
          : !fromExport && CurrentProject.canvasSize === "9:16"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/potrait/" +
            filename
          : authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/" +
            filename,

      // character_FilePath: fromExport
      //   ? "/Assets/SlideTransitions/" + filename
      //   : authenticationData.ApiBaseURL +
      //   "/Assets/SlideTransitions/" +
      //   filename,

      //character_FilePath: authenticationData.ApiBaseURL + '/Assets/SlideTransitions/2.json',
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      x: 0,
      y: 0,
      opacity: 1,
      width: PopupWidthHeight.width,
      height: PopupWidthHeight.height,
      toolbar: false,
      FurtherSetting: false,
      lock: false,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      CharacterStop: true,
      CharacterPause: false,
      CharacterPlayed: false,
      startPositionOnTimeline: 0, //TickerPosition,
      player: false,
      Animate: false,
      flip: "scaleX(1)",
      rotateAngle: 0,
      AzData: null,
      reverse: true,
    };
    newEntryLayerData.widthOnTimeline = calculateWidthByDurationRelative(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    return newEntryLayerData;
  };

  const getSlideTtransition1_ForExport = (
    type,
    name,
    key,
    _duration,
    filename,
    fromExport = false
  ) => {
    let newEntryLayerData = {
      AnimationId: makeid(7),
      key: key,
      type: "SlideTransition", //"Character",
      bgColor: "#00adff",
      Name: `Slide-Transition-${name}`,
      canvas: null,
      userFile: "xyz",
      transition: 1,
      layerIndex: 1,
      index: null,
      TimelineZoom: 6, //timelineZoomVal,
      duration: _duration, //totalTime,
      startTime: "00:00:00:009", //currentTime,
      endTime: _duration, //calculateTimeByWidth(Tl_TotalTime.width),
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      typeIcon: "person",
      character_poses: [], //props.obj.poses,
      ImageSrc: "",

      //character_FilePath: authenticationData.ApiBaseURL + '/Assets/SlideTransitions/lf20_jlj5m1il.json', //with out .json

      // character_FilePath: fromExport
      //   ? "/Assets/SlideTransitions/" + filename
      //   : authenticationData.ApiBaseURL +
      //   "/Assets/SlideTransitions/" +
      //   filename,
      character_FilePath:
        fromExport && CurrentProject.canvasSize === "16:9"
          ? "/Assets/SlideTransitions/" + filename
          : fromExport && CurrentProject.canvasSize === "1:1"
          ? "/Assets/SlideTransitions/square/" + filename
          : fromExport && CurrentProject.canvasSize === "9:16"
          ? "/Assets/SlideTransitions/potrait/" + filename
          : !fromExport && CurrentProject.canvasSize === "16:9"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/" +
            filename
          : !fromExport && CurrentProject.canvasSize === "1:1"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/square/" +
            filename
          : !fromExport && CurrentProject.canvasSize === "9:16"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/potrait/" +
            filename
          : authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/" +
            filename,
      //: authenticationData.ApiBaseURL + "/Assets/SlideTransitions/square/" + filename,

      //with out .json
      //character_FilePath: authenticationData.ApiBaseURL + '/Assets/SlideTransitions/2.json', //with out .json
      //character_FilePath: "https://assets1.lottiefiles.com/packages/lf20_y29qdwhx.json",
      //character_FilePath: "https://assets1.lottiefiles.com/packages/lf20_7ti3aixq.json",
      // character_FilePath: "https://assets1.lottiefiles.com/packages/lf20_p1yzsk52.json",
      //character_FilePath: "https://assets1.lottiefiles.com/packages/lf20_scgoh91m.json",
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      x: 0,
      y: 0,
      opacity: 1,
      width: PopupWidthHeight.width,
      height: PopupWidthHeight.height,
      toolbar: false,
      FurtherSetting: false,
      lock: false,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      CharacterStop: true,
      CharacterPause: false,
      CharacterPlayed: false,
      startPositionOnTimeline: 160, //TickerPosition,
      player: false,
      Animate: false,
      flip: "scaleX(1)",
      rotateAngle: 0,
      AzData: null,
      reverse: false,
    };
    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    return newEntryLayerData;
  };

  const getSlideTtransition2_ForExport = (
    type,
    name,
    key,
    _duration,
    filename,
    fromExport = false
  ) => {
    let newEntryLayerData = {
      AnimationId: makeid(7),
      key: key,
      type: "SlideTransition", //"Character",
      bgColor: "#00adff",
      Name: `Slide-Transition-${name}`,
      canvas: null,
      userFile: "xyz",
      transition: 2,
      layerIndex: 1,
      index: null,
      TimelineZoom: 6, //timelineZoomVal,
      duration: _duration, //totalTime,
      startTime: "00:00:00:009", //currentTime,
      endTime: _duration, //calculateTimeByWidth(Tl_TotalTime.width),
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      typeIcon: "person",
      character_poses: [], //props.obj.poses,
      ImageSrc: "",
      //character_FilePath: authenticationData.ApiBaseURL + '/Assets/SlideTransitions/Transition1_2.json',

      character_FilePath:
        fromExport && CurrentProject.canvasSize === "16:9"
          ? "/Assets/SlideTransitions/" + filename
          : fromExport && CurrentProject.canvasSize === "1:1"
          ? "/Assets/SlideTransitions/square/" + filename
          : fromExport && CurrentProject.canvasSize === "9:16"
          ? "/Assets/SlideTransitions/potrait/" + filename
          : !fromExport && CurrentProject.canvasSize === "16:9"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/" +
            filename
          : !fromExport && CurrentProject.canvasSize === "1:1"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/square/" +
            filename
          : !fromExport && CurrentProject.canvasSize === "9:16"
          ? authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/potrait/" +
            filename
          : authenticationData.ApiBaseURL +
            "/Assets/SlideTransitions/" +
            filename,

      // character_FilePath: fromExport
      //   ? "/Assets/SlideTransitions/" + filename
      //   : authenticationData.ApiBaseURL +
      //   "/Assets/SlideTransitions/" +
      //   filename,

      //character_FilePath: authenticationData.ApiBaseURL + '/Assets/SlideTransitions/2.json',
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      x: 0,
      y: 0,
      opacity: 1,
      width: PopupWidthHeight.width,
      height: PopupWidthHeight.height,
      toolbar: false,
      FurtherSetting: false,
      lock: false,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      CharacterStop: true,
      CharacterPause: false,
      CharacterPlayed: false,
      startPositionOnTimeline: 0, //TickerPosition,
      player: false,
      Animate: false,
      flip: "scaleX(1)",
      rotateAngle: 0,
      AzData: null,
      reverse: true,
    };
    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    return newEntryLayerData;
  };

  const convertLayer = (layer, width, height, Currwidth, Currheight) => {
    const array = Array.from(layer);
    if (height && width) {
      let heightRatio = height / Currheight;
      let widthRatio = width / Currwidth;
      for (let i = 0; i < array.length; i++) {
        if (array[i].x && array[i].width && array[i].y && array[i].height) {
          array[i].x = array[i].x / widthRatio;
          array[i].width = array[i].width / widthRatio;
          array[i].y = array[i].y / heightRatio;
          array[i].height = array[i].height / heightRatio;
        }
        if (array[i].originalX) {
          array[i].originalX = array[i].originalX / widthRatio;
        }
        if (array[i].originalY) {
          array[i].originalY = array[i].originalY / heightRatio;
        }
        if (array[i].originalWidth) {
          array[i].originalWidth = array[i].originalWidth / widthRatio;
        }
        if (array[i].originalHeight) {
          array[i].originalHeight = array[i].originalHeight / heightRatio;
        }
        if (array[i].fontSize) {
          array[i].fontSize = parseInt(array[i].fontSize / heightRatio);
        }
        if (array[i].originalFontSize) {
          array[i].originalFontSize = parseInt(
            array[i].originalFontSize / heightRatio
          );
        }
      }
    }
    return array;
  };

  // Real slide transition lengths, read in the background so the preview can use them at once.
  useEffect(() => {
    if (slides && CurrentProject && authenticationData) {
      preloadSlideTransitions(authenticationData.ApiBaseURL, slides, CurrentProject.canvasSize);
    }
  }, [slides, CurrentProject && CurrentProject.canvasSize]);

  useEffect(async () => {
    if (popupload) {
      let height =
          document.getElementsByClassName("EditorTrackInner")[0].offsetHeight,
        width =
          document.getElementsByClassName("EditorTrackInner")[0].offsetWidth,
        Currwidth = PopupWidthHeight.width,
        Currheight = PopupWidthHeight.height,
        // heightRatio = height / Currheight,
        // widthRatio = width / Currwidth,
        heightRatio = Currheight / height,
        widthRatio = Currwidth / width,
        time = 0,
        array = clone(slides),
        slideData = [],
        bgData = [];
      //console.log("LayersData: ", LayersData);

      for (let i = 0; i < array.length; i++) {
        let data = {};
        if (array[i].SlideBackground.type === "color") {
          data = { background: array[i].SlideBackground.color };
        } else if (array[i].SlideBackground.type === "gradient") {
          data = { background: array[i].SlideBackground.gradient.Gcolor };
        } else if (array[i].SlideBackground.type === "Animated") {
          data = {
            backgroundImage: `url(${
              authenticationData.ApiBaseURL +
              "/" +
              array[i].SlideBackground.Path
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            animationPath:
              authenticationData.ApiBaseURL +
              "/" +
              array[i].SlideBackground.AnimationPath,
          };
        } else if (array[i].SlideBackground.type === "image") {
          if (
            !array[i].SlideBackground.Path.includes("data:image/png;base64") &&
            !array[i].SlideBackground.Path.includes("data:image/jpeg;base64")
          ) {
            data = {
              backgroundImage: `url(${
                authenticationData.ApiBaseURL +
                "/" +
                array[i].SlideBackground.Path
              })`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            };
          } else {
            data = {
              backgroundImage: `url(${
                authenticationData.ApiBaseURL +
                "/" +
                array[i].SlideBackground.Path
              })`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            };
          }
        }

        let obj = {
          time: time,
          background: data,
        };

        bgData.push(obj);

        if (array[i].IsActive) {
          var arr = clone(LayersData);

          for (let j = 0; j < arr.length; j++) {
            // arr[j] = await convertLayer(
            //   arr[i],
            //   array[i].canvasWidth,
            //   array[i].canvasHeight,
            //   width,
            //   height
            // );
            ///////////////
            // arr[j].startPositionOnTimeline =
            //   time + totalTimeToMs(arr[j].startTime);

            arr[j].startPositionOnTimeline =
              array[i].startBackground + arr[j].startPositionOnTimeline;

            arr[j].startMusic = false;
            arr[j].opacity = arr[j].originalOpacity;
            if (arr[j].originalX) {
              arr[j].x = arr[j].originalX;
            }
            if (arr[j].originalY) {
              arr[j].y = arr[j].originalY;
            }

            arr[j].time = time;

            arr[j].DrapEndAnimatedText = false;
            arr[j].endTimeOfAnimatedText = undefined;
            arr[j].speedOn = false;
            arr[j].fastspeedOn = false;
            arr[j].startTimeOnTimeline = false;
            arr[j].LoadLottie = false;
            arr[j].TotalSlideTime = array[i].endBackground;

            if (arr[j].LastStartPositionOnTimeline) {
              arr[j].LastStartPositionOnTimeline =
                array[i].startBackground + arr[j].LastStartPositionOnTimeline;
              if (
                arr[j].LastStartPositionOnTimeline ===
                arr[j].startPositionOnTimeline
              ) {
                if (arr[j].type !== "AnimatedText") {
                  if (
                    arr[j].widthOnTimeline +
                      arr[j].LastStartPositionOnTimeline >
                    array[i].endBackground
                  ) {
                    arr[j].widthOnTimeline = Math.abs(
                      arr[j].LastStartPositionOnTimeline -
                        array[i].endBackground
                    );
                  }
                }
              } else {
                if (arr[j].type !== "AnimatedText") {
                  if (
                    arr[j].widthOnTimeline + arr[j].startPositionOnTimeline >
                    array[i].endBackground
                  ) {
                    arr[j].widthOnTimeline = Math.abs(
                      arr[j].startPositionOnTimeline - array[i].endBackground
                    );
                  }
                }
              }
            } else {
              if (arr[j].type !== "AnimatedText") {
                if (
                  arr[j].widthOnTimeline + arr[j].startPositionOnTimeline >
                  array[i].endBackground
                ) {
                  arr[j].widthOnTimeline = Math.abs(
                    arr[j].startPositionOnTimeline - array[i].endBackground
                  );
                }
              }
            }

            let startTransPerc =
              arr[j].startTransitionWidth / arr[j].widthOnTimeline;

            // if (
            //   totalTimeToMs(array[i].TotalLength) <
            //   totalTimeToMs(arr[j].endTime)
            // ) {
            //   arr[j].widthOnTimeline =
            //     totalTimeToMs(array[i].TotalLength) -
            //     totalTimeToMs(arr[j].startTime);
            // } else {
            //   arr[j].widthOnTimeline = totalTimeToMs(arr[j].duration);
            // }

            // arr[j].widthOnTimeline = array[i].startBackground + arr[j].widthOnTimeline;

            arr[j].Audio = LayersData[j].Audio;

            // arr[j].JSONValue.assets[1].layers[0].hd = false;
            // const _JSONValue = JSON.parse(localStorage.getItem("JSONValue"+arr[j].AnimationId))
            // // arr[j].AnimationId = arr[j].AnimationId + "inPreview";

            // if(_JSONValue)
            // {
            //   arr[j].JSONValue = _JSONValue;
            //   localStorage.removeItem("JSONValue"+arr[j].AnimationId)
            // }

            ///////////////////////////////
            // arr[j].startTransitionWidth =
            //   arr[j].widthOnTimeline * startTransPerc;

            arr[j].startTransitionWidth =
              array[i].startBackground + arr[j].startTransitionWidth;

            arr[j].InClass = "";
            arr[j].OutClass = "";

            if (arr[j].type == "text") {
              if (arr[j].TextId) {
                arr[j].TextId = makeid(8);
              }

              if (arr[j].WordsArray) {
                for (let k = 0; k < arr[j].WordsArray.length; k++) {
                  arr[j].WordsArray[k].id = `wbwf_${makeid(8)}`;
                }
              }

              if (arr[j].wordByWordFadeInData) {
                if (arr[j].wordByWordFadeInData.cleanWordsArray) {
                  for (
                    let k = 0;
                    k < arr[j].wordByWordFadeInData.cleanWordsArray.length;
                    k++
                  ) {
                    arr[
                      j
                    ].wordByWordFadeInData.cleanWordsArray.id = `wbwf_${makeid(
                      8
                    )}`;
                  }
                }
              }

              // debugger
              if (arr[j].CharactersArray) {
                for (let k = 0; k < arr[j].CharactersArray.length; k++) {
                  arr[i].CharactersArray[k].id = `wbwf_${makeid(8)}`;
                }
              }

              // debugger
              if (arr[j].fontSize) {
                let measureZoom = (arr[j].fontSize * projectEditorZoom) / 100;
                arr[j].fontSize = measureZoom * heightRatio;
                // arr[j].fontSize = parseInt(arr[j].fontSize / heightRatio);

                arr[j].originalFontSize = arr[j].fontSize;
                // arr[j].originalText = arr[j].text;
              }
            }
            //debugger;

            if (
              arr[j].x != undefined ||
              (arr[j].x != null && arr[j].width != undefined) ||
              (arr[j].width != null && arr[j].y != undefined) ||
              (arr[j].y != null && arr[j].height != undefined) ||
              arr[j].height != null
            ) {
              // if(arr[j].type === "basicShape")
              // {
              //   arr[j].x = arr[j].x / widthRatio //302.80 /// 0.74 //(widthRatio + 0.02);
              //   arr[j].width = arr[j].width / widthRatio;
              //   arr[j].y = arr[j].y / heightRatio // (heightRatio + 1.027);
              //   arr[j].height = arr[j].height /  heightRatio;
              // }
              // else
              // {
              // debugger;
              // arr[j].x = arr[j].x + (Currwidth - height);
              //arr[j].x = arr[j].x / widthRatio;

              // width ratio is actually ... Preview canvas divided by EditorCanvas

              let measureZoom = (arr[j].width * projectEditorZoom) / 100;
              arr[j].width = measureZoom * widthRatio;

              measureZoom = (arr[j].height * projectEditorZoom) / 100;
              arr[j].height = measureZoom * heightRatio;
              // }

              measureZoom = (arr[j].x * projectEditorZoom) / 100;
              arr[j].x = measureZoom * widthRatio;

              measureZoom = (arr[j].y * projectEditorZoom) / 100;
              arr[j].y = measureZoom * heightRatio;
              // arr[j].y = arr[j].y / 1.013 / heightRatio;
              arr[j].originalX = arr[j].x;
              arr[j].originalY = arr[j].y;
              arr[j].originalWidth = arr[j].width;
              arr[j].originalHeight = arr[j].height;
              arr[j].originalOpacity = arr[j].opacity;
              arr[j].originalRotateAngle = arr[j].rotateAngle;
            }
            arr[j].Editable = false;
            arr[j].FurtherSetting = false;

            slideData.push(arr[j]);
          }
        } else {
          for (let j = 0; j < array[i].LayerData.length; j++) {
            /////////////////////////
            // array[i].LayerData[j].startPositionOnTimeline =
            //   time + totalTimeToMs(array[i].LayerData[j].startTime);

            // array[i].LayerData[j] = await convertLayer(
            //   array[i].LayerData[j],
            //   array[i].canvasWidth,
            //   array[i].canvasHeight,
            //   width,
            //   height
            // );

            array[i].LayerData[j].startPositionOnTimeline =
              array[i].startBackground +
              array[i].LayerData[j].startPositionOnTimeline;

            array[i].LayerData[j].startMusic = false;
            array[i].LayerData[j].opacity =
              array[i].LayerData[j].originalOpacity;
            // Same rule as for the slide being edited (above): the saved start position is only
            // used when there is one. Before, x/y were always replaced by originalX/originalY,
            // which most layers do not have (or have as 0) until they are dragged, so on every
            // other slide those layers were drawn stacked in the top-left corner of the preview.
            if (array[i].LayerData[j].originalX) {
              array[i].LayerData[j].x = array[i].LayerData[j].originalX;
            }
            if (array[i].LayerData[j].originalY) {
              array[i].LayerData[j].y = array[i].LayerData[j].originalY;
            }

            array[i].LayerData[j].DrapEndAnimatedText = false;
            array[i].LayerData[j].endTimeOfAnimatedText = undefined;
            array[i].LayerData[j].speedOn = false;
            array[i].LayerData[j].fastspeedOn = false;
            array[i].LayerData[j].startTimeOnTimeline = false;
            array[i].LayerData[j].LoadLottie = false;
            array[i].LayerData[j].time = time;
            array[i].LayerData[j].TotalSlideTime = array[i].endBackground;

            if (array[i].LayerData[j].LastStartPositionOnTimeline) {
              array[i].LayerData[j].LastStartPositionOnTimeline =
                array[i].startBackground +
                array[i].LayerData[j].LastStartPositionOnTimeline;
              if (
                array[i].LayerData[j].LastStartPositionOnTimeline ===
                array[i].LayerData[j].startPositionOnTimeline
              ) {
                if (array[i].LayerData[j].type !== "AnimateText") {
                  if (
                    array[i].LayerData[j].widthOnTimeline +
                      array[i].LayerData[j].LastStartPositionOnTimeline >
                    array[i].endBackground
                  ) {
                    array[i].LayerData[j].widthOnTimeline = Math.abs(
                      array[i].LayerData[j].LastStartPositionOnTimeline -
                        array[i].endBackground
                    );
                  }
                }
              } else {
                if (array[i].LayerData[j].type !== "AnimateText") {
                  if (
                    array[i].LayerData[j].widthOnTimeline +
                      array[i].LayerData[j].startPositionOnTimeline >
                    array[i].endBackground
                  ) {
                    array[i].LayerData[j].widthOnTimeline = Math.abs(
                      array[i].LayerData[j].startPositionOnTimeline -
                        array[i].endBackground
                    );
                  }
                }
              }
            } else {
              if (array[i].LayerData[j].type !== "AnimateText") {
                if (
                  array[i].LayerData[j].widthOnTimeline +
                    array[i].LayerData[j].startPositionOnTimeline >
                  array[i].endBackground
                ) {
                  array[i].LayerData[j].widthOnTimeline = Math.abs(
                    array[i].LayerData[j].startPositionOnTimeline -
                      array[i].endBackground
                  );
                }
              }
            }

            let startTransPerc =
              array[i].LayerData[j].startTransitionWidth /
              array[i].LayerData[j].widthOnTimeline;

            // if (
            //   totalTimeToMs(array[i].TotalLength) <
            //   totalTimeToMs(array[i].LayerData[j].endTime)
            // ) {
            //   array[i].LayerData[j].widthOnTimeline =
            //     totalTimeToMs(array[i].TotalLength) -
            //     totalTimeToMs(array[i].LayerData[j].startTime);
            // } else {
            //   array[i].LayerData[j].widthOnTimeline = totalTimeToMs(
            //     array[i].LayerData[j].duration
            //   );
            // }
            //////////////////////////
            // array[i].LayerData[j].startTransitionWidth =
            //   array[i].LayerData[j].widthOnTimeline * startTransPerc;

            array[i].LayerData[j].startTransitionWidth =
              array[i].startBackground +
              array[i].LayerData[j].startTransitionWidth;

            array[i].LayerData[j].InClass = "";
            array[i].LayerData[j].OutClass = "";

            if (array[i].LayerData[j].type == "text") {
              if (array[i].LayerData[j].TextId) {
                array[i].LayerData[j].TextId = makeid(8);
              }

              if (array[i].LayerData[j].WordsArray) {
                for (
                  let k = 0;
                  k < array[i].LayerData[j].WordsArray.length;
                  k++
                ) {
                  array[i].LayerData[j].WordsArray[k].id = `wbwf_${makeid(8)}`;
                }
              }

              if (array[i].LayerData[j].wordByWordFadeInData) {
                if (
                  array[i].LayerData[j].wordByWordFadeInData.cleanWordsArray
                ) {
                  for (
                    let k = 0;
                    k <
                    array[i].LayerData[j].wordByWordFadeInData.cleanWordsArray
                      .length;
                    k++
                  ) {
                    array[i].LayerData[
                      j
                    ].wordByWordFadeInData.cleanWordsArray.id = `wbwf_${makeid(
                      8
                    )}`;
                  }
                }
              }

              if (array[i].LayerData[j].CharactersArray) {
                for (
                  let k = 0;
                  k < array[i].LayerData[j].CharactersArray.length;
                  k++
                ) {
                  array[i].LayerData[j].CharactersArray[k].id = `wbwf_${makeid(
                    8
                  )}`;
                }
              }

              if (array[i].LayerData[j].fontSize) {
                let measureZoom =
                  (array[i].LayerData[j].fontSize * projectEditorZoom) / 100;
                array[i].LayerData[j].fontSize = measureZoom * heightRatio;

                array[i].LayerData[j].originalFontSize =
                  array[i].LayerData[j].fontSize;
                // arr[j].originalText = arr[j].text;
              }
            }

            if (
              // A layer at the very left or top edge has x or y = 0; it must be scaled too
              // (a truthiness check skipped it, so on other slides it kept its editor size).
              Number.isFinite(array[i].LayerData[j].x) &&
              array[i].LayerData[j].width &&
              Number.isFinite(array[i].LayerData[j].y) &&
              array[i].LayerData[j].height
            ) {
              // width ratio is actually ... Preview canvas divided by EditorCanvas
              let measureZoom =
                (array[i].LayerData[j].width * projectEditorZoom) / 100;
              array[i].LayerData[j].width = measureZoom * widthRatio;

              measureZoom =
                (array[i].LayerData[j].height * projectEditorZoom) / 100;
              array[i].LayerData[j].height = measureZoom * heightRatio;
              // }

              measureZoom = (array[i].LayerData[j].x * projectEditorZoom) / 100;
              array[i].LayerData[j].x = measureZoom * widthRatio;

              measureZoom = (array[i].LayerData[j].y * projectEditorZoom) / 100;
              array[i].LayerData[j].y = measureZoom * heightRatio;
              // array[i].LayerData[j].y = array[i].LayerData[j].y / 1.013 / heightRatio;
              array[i].LayerData[j].originalX = array[i].LayerData[j].x;
              array[i].LayerData[j].originalY = array[i].LayerData[j].y;
              array[i].LayerData[j].originalWidth = array[i].LayerData[j].width;
              array[i].LayerData[j].originalHeight =
                array[i].LayerData[j].height;
              array[i].LayerData[j].originalOpacity =
                array[i].LayerData[j].opacity;
              array[i].LayerData[j].originalRotateAngle =
                array[i].LayerData[j].rotateAngle;
            }

            array[i].Editable = false;
            array[i].FurtherSetting = false;

            array[i].LayerData[j].Audio = slides[i].LayerData[j].Audio;
            slideData.push(array[i].LayerData[j]);
          }
        }

        // Slide transition into this slide: one definition for preview and export
        // (Utils/slideTransitions.js). Part 1 ends exactly at the slide change, part 2 starts there,
        // each as long as its animation really is.
        // No waiting here: the preview sets itself up the moment it opens, from the data that
        // exists then (waiting for the network left the preview empty). Lengths are preloaded.
        const _transition = i > 0 ? getSlideTransitionNow(array[i], CurrentProject.canvasSize) : null;
        if (_transition) {
          let transitionObj1 = getSlideTtransition1(
            array[i].transitionType,
            array[i].transitionName,
            1,
            secondsToTimeString(_transition.seconds[0]),
            ""
          );
          transitionObj1.character_FilePath = authenticationData.ApiBaseURL + _transition.files[0];
          transitionObj1.startPositionOnTimeline =
            array[i].startBackground - transitionObj1.widthOnTimeline;
          transitionObj1.time = time;
          slideData.push(transitionObj1);

          let transitionObj2 = getSlideTtransition2(
            array[i].transitionType,
            array[i].transitionName,
            2,
            secondsToTimeString(_transition.seconds[1]),
            ""
          );
          transitionObj2.character_FilePath = authenticationData.ApiBaseURL + _transition.files[1];
          transitionObj2.startPositionOnTimeline = array[i].startBackground;
          transitionObj2.time = time;
          slideData.push(transitionObj2);
        }

        time += totalTimeToMs(array[i].TotalLength);
      }

      let counter = 0;
      let loadedCounter = 0;
      let unLoadedCounter = 0;
      for (let i = 0; i < slideData.length; i++) {
        if (slideData[i].type == "basicShape" || slideData[i].type == "text") {
          slideData[i].isLoaded = true;
          loadedCounter++;
        } else {
          slideData[i].isLoaded = false;
          counter++;
          unLoadedCounter++;
        }
        slideData[i].previewKey = i + 1;
      }
      // setLoadCounter(loadedCounter);
      setUnloadedCounter(unLoadedCounter);
      _unloadedCounter = unLoadedCounter;

      sessionStorage.setItem("LoadCounter", JSON.stringify(LoadCounter));
      setSlideBackground(bgData);

      if (slideData.length > 0) setSlidesData(slideData);
      else setIsLoaded(true);
      //debugger;
      // setLayersData(slideData)
      setSupremeLayer({
        TotalTime: time,
        Layer: slideData,
        setInEditor: true,
      });
    } else {
      if (sessionStorage.getItem("LoadCounter")) {
        sessionStorage.removeItem("LoadCounter");
      }

      if (slides) {
        const slide_array = Array.from(slides);
        const layers_array = Array.from(LayersData);
        let change = false;

        slide_array.map((slide_value) => {
          if (slide_value.IsActive) {
            layers_array.map((layer_value) => {
              if (layer_value.type === "AnimatedText") {
                layer_value.Added = true;
              }
            });
          } else {
            slide_value.LayerData.map((sl_value) => {
              if (sl_value.type === "AnimatedText") {
                sl_value.Added = true;
              }
            });
          }
        });

        setslides(slide_array);
        setLayersData(layers_array);
      }

      setIsLoaded(false);
      setLoadCounter([]);
      setSlidesData([]);
      setSupremeLayer({
        TotalTime: "",
        Layer: "",
      });
    }
  }, [popupload]);

  function msToTime2(duration) {
    var seconds = (duration / 1000) % 60,
      minutes = Math.floor((duration / (1000 * 60)) % 60),
      minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return minutes + ":" + seconds;
  }

  const ForEmergencyLottiePlayer = async (value) => {
    const data = Lottie.getRegisteredAnimations();
    data.map((LottieData) => {
      if (LottieData.name == value.AnimationId) {
        Lottie.destroy(value.AnimationId);
      }
    });

    const resp = await fetch(value.character_FilePath);
    const jsonData = await resp.json();

    let _svg = document.createElement("div");
    _svg.id = value.AnimationId;
    _svg.style.display = "none";

    const get = Lottie.loadAnimation({
      container: _svg,
      name: value.AnimationId,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: jsonData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMin slice",
        viewBoxOnly: true,
        progressiveLoad: true,
      },
    });

    document.getElementsByTagName("body")[0].appendChild(_svg);

    return get;
  };

  useEffect(async () => {
    if (CallForExport.status) {
     try {
      let array = clone(slides),
        OnePx = null,
        height =
          document.getElementsByClassName("EditorTrackInner")[0].offsetHeight,
        width =
          document.getElementsByClassName("EditorTrackInner")[0].offsetWidth,
        Currwidth = PopupWidthHeight.width,
        Currheight = PopupWidthHeight.height,
        heightRatio = Currheight / height,
        widthRatio = Currwidth / width,
        time = 0,
        TotalTimeOfAllSlide = 0,
        slideData = [],
        bgData = [],
        EditorZoom = window.localStorage.getItem("EditorZoom")
          ? window.localStorage.getItem("EditorZoom")
          : 100;

      const arr = clone(LayersData);
      let zInd = 0;
      for (let i = 0; i < array.length; i++) {
        let data = {};

        if (array[i].onePxEquivalent) OnePx = array[i].onePxEquivalent;
        if (array[i].SlideBackground.type === "color") {
          data = { background: array[i].SlideBackground.color };
        } else if (array[i].SlideBackground.type === "gradient") {
          data = { background: array[i].SlideBackground.gradient.Gcolor };
        } else if (array[i].SlideBackground.type === "Animated") {
          // (The renderer loads the animation from its path; no image conversion needed.)
          data = {
            animationPath: array[i].SlideBackground.AnimationPath,
            AnimationId: makeid(8),
          };
        } else if (array[i].SlideBackground.type === "image") {
          // The renderer loads the image from its path, so it is not converted to base64 here.
          // (Converting made the export request much bigger, and when the conversion failed the
          // export silently never started.)
          if (
            !String(array[i].SlideBackground.Path || "").includes("data:image/png;base64") &&
            !String(array[i].SlideBackground.Path || "").includes("data:image/jpeg;base64")
          ) {
            data = {
              backgroundImage: "/" + array[i].SlideBackground.Path,
              backgroundSize: "cover",
              backgroundPosition: "center",
            };
          } else {
            data = {
              backgroundImage: array[i].SlideBackground.Path,
              backgroundSize: "cover",
              backgroundPosition: "center",
            };
          }
        }
        let obj = {
          startTime: parseInt((time / 1000) * CallForExport.fps),
          endTime: parseInt(
            ((totalTimeToMs(array[i].TotalLength) + time) / 1000) *
              CallForExport.fps
          ),
          background: data,
          type: array[i].SlideBackground.type,
          index: i + 1,
          EditorZoom: EditorZoom,
          startBackground: array[i].startBackground,
          endBackground: array[i].startBackground + array[i].scaleEnd,
        };
        bgData.push(obj);

        {
          // Slide transition into this slide: same definition as the preview
          // (Utils/slideTransitions.js). Part 1 ends exactly at the slide change, part 2 starts
          // there, each as long as its animation really is. (Before: fixed lengths that did not
          // match the animations, and both parts stretched to 1.5x, so part 1 stayed on top of the
          // reveal and the next slide popped in late.)
          const _transition =
            i > 0
              ? await getSlideTransition(authenticationData.ApiBaseURL, array[i], CurrentProject.canvasSize)
              : null;
          if (_transition) {
            const _parts = [1, 2].map((part) => {
              const make = part === 1 ? getSlideTtransition1 : getSlideTtransition2;
              const obj = make(
                array[i].transitionType,
                array[i].transitionName,
                part,
                secondsToTimeString(_transition.seconds[part - 1]),
                ""
              );
              obj.character_FilePath = authenticationData.ApiBaseURL + _transition.files[part - 1];
              obj.startPositionOnTimeline =
                part === 1 ? array[i].startBackground - obj.widthOnTimeline : array[i].startBackground;
              obj.time = time;
              obj.EditorZoom = EditorZoom;
              const startMs = obj.startPositionOnTimeline * Number(localStorage.getItem("onePxEquivalent") || OnePx || 8.620689655172415);
              obj.StartFrame = Math.max(0, Math.round((startMs / 1000) * CallForExport.fps));
              obj.TotalFrames = obj.StartFrame + Math.round(_transition.seconds[part - 1] * CallForExport.fps);
              return obj;
            });
            slideData.push(_parts[0]);
            slideData.push(_parts[1]);
          }
        }

        if (array[i].IsActive) {
          for (let j = 0; j < arr.length; j++) {
            zInd = zInd + 1;
            arr[j].index = zInd;

            arr[j].startPositionOnTimeline =
              array[i].startBackground + arr[j].startPositionOnTimeline;
            if (arr[j].widthOnTimeline > array[i].endBackground) {
              arr[j].TotalFrames = parseInt(
                ((totalTimeToMs(array[i].TotalLength) + time) / 1000) *
                  CallForExport.fps
              );
            } else {
              arr[j].TotalFrames = parseInt(
                ((totalTimeToMs(arr[j].duration) + time) / 1000) *
                  CallForExport.fps
              );
            }

            if (arr[j].LastStartPositionOnTimeline) {
              arr[j].LastStartPositionOnTimeline =
                array[i].startBackground + arr[j].LastStartPositionOnTimeline;
              if (
                arr[j].LastStartPositionOnTimeline ===
                arr[j].startPositionOnTimeline
              ) {
                if (
                  arr[j].widthOnTimeline + arr[j].LastStartPositionOnTimeline >
                  array[i].endBackground
                ) {
                  arr[j].widthOnTimeline = Math.abs(
                    arr[j].LastStartPositionOnTimeline - array[i].endBackground
                  );
                }
              } else {
                if (
                  arr[j].widthOnTimeline + arr[j].startPositionOnTimeline >
                  array[i].endBackground
                ) {
                  arr[j].widthOnTimeline = Math.abs(
                    arr[j].startPositionOnTimeline - array[i].endBackground
                  );
                }
              }
            } else {
              if (
                arr[j].widthOnTimeline + arr[j].startPositionOnTimeline >
                array[i].endBackground
              ) {
                arr[j].widthOnTimeline = Math.abs(
                  arr[j].startPositionOnTimeline - array[i].endBackground
                );
              }
            }

            arr[j].EditorZoom = EditorZoom;
            if (OnePx && arr[i]) arr[i].OnePx = OnePx;
            arr[j].StartFrame = parseInt(
              ((totalTimeToMs(arr[j].startTime) + time) / 1000) *
                CallForExport.fps
            );

            // If In Effect Exit
            if (arr[j].InEffect === "animated slideInLeft ") {
              var totalwidth =
                array[i].originalX -
                document.getElementsByClassName("EditorTrackInner")[0]
                  .clientWidth;
            }

            arr[j].time = time;

            // if (arr[j].LastStartPositionOnTimeline) {
            //   arr[j].LastStartPositionOnTimeline =
            //     array[i].startBackground + arr[j].LastStartPositionOnTimeline;

            //   if (
            //     arr[j].widthOnTimeline + arr[j].LastStartPositionOnTimeline >
            //     array[i].endBackground
            //   ) {
            //     arr[j].widthOnTimeline = Math.abs(
            //       arr[j].LastStartPositionOnTimeline - array[i].endBackground
            //     );
            //   }
            // } else {
            //   if (
            //     arr[j].widthOnTimeline + arr[j].startPositionOnTimeline >
            //     array[i].endBackground
            //   ) {
            //     arr[j].widthOnTimeline = Math.abs(
            //       arr[j].startPositionOnTimeline - array[i].endBackground
            //     );
            //   }
            // }

            let startTransPerc =
              arr[j].startTransitionWidth / arr[j].widthOnTimeline;
            let endTransPerc =
              arr[j].endTransitionWidth / arr[j].widthOnTimeline;

            // arr[j].startTransitionWidth =
            //   array[i].startBackground + arr[j].startTransitionWidth;

            arr[j].endTransitionWidth =
              array[i].startBackground + arr[j].endTransitionWidth;

            arr[j].endTransitionLeft =
              arr[j].widthOnTimeline - arr[j].endTransitionWidth;

            arr[j].InClass = "";
            arr[j].OutClass = "";
            arr[j].Editable = false;
            arr[j].FurtherSetting = false;
            arr[j].SlideNo = i;
            arr[j].SlideLength = array[i].TotalLength;

            var diff = arr[j].endTime;

            var tlength = totalTimeToMs(
              calculateTimeByWidth(
                slides.filter((x) => x.IsActive == true)[0].TotalSlideWidth
              )
            );
            var dif = totalTimeToMs(diff);
            if (arr[j].type == "audio") {
              // if (arr[j].Name === "audio-3") {
              //   debugger;
              // }
              if (dif > tlength) {
                var diff2 = dif - tlength;
                arr[j].endSound = convertSecondtoTimeString(
                  (dif - diff2) / 1000
                );
              } else {
                arr[j].endSound = diff;
              }
            }

            if (arr[j].type === "audio" && arr[j].startSound) {
              arr[j].startSoundInSeconds = calculateTimeByWidth(
                arr[j].startSound
              );
            }
            slideData.push(arr[j]);
          }
        } else {
          for (let j = 0; j < array[i].LayerData.length; j++) {
            zInd = zInd + 1;
            array[i].LayerData[j].index = zInd;
            if (
              array[i].LayerData[j].widthOnTimeline > array[i].endBackground
            ) {
              array[i].LayerData[j].TotalFrames = parseInt(
                ((totalTimeToMs(array[i].TotalLength) + time) / 1000) *
                  CallForExport.fps
              );
            } else {
              array[i].LayerData[j].TotalFrames = parseInt(
                ((totalTimeToMs(array[i].LayerData[j].duration) + time) /
                  1000) *
                  CallForExport.fps
              );
            }

            array[i].LayerData[j].startPositionOnTimeline =
              array[i].startBackground +
              array[i].LayerData[j].startPositionOnTimeline;

            if (array[i].LayerData[j].LastStartPositionOnTimeline) {
              array[i].LayerData[j].LastStartPositionOnTimeline =
                array[i].startBackground +
                array[i].LayerData[j].LastStartPositionOnTimeline;
              if (
                array[i].LayerData[j].LastStartPositionOnTimeline ===
                array[i].LayerData[j].startPositionOnTimeline
              ) {
                if (
                  array[i].LayerData[j].widthOnTimeline +
                    array[i].LayerData[j].LastStartPositionOnTimeline >
                  array[i].endBackground
                ) {
                  array[i].LayerData[j].widthOnTimeline = Math.abs(
                    array[i].LayerData[j].LastStartPositionOnTimeline -
                      array[i].endBackground
                  );
                }
              } else {
                if (
                  array[i].LayerData[j].widthOnTimeline +
                    array[i].LayerData[j].startPositionOnTimeline >
                  array[i].endBackground
                ) {
                  array[i].LayerData[j].widthOnTimeline = Math.abs(
                    array[i].LayerData[j].startPositionOnTimeline -
                      array[i].endBackground
                  );
                }
              }
            } else {
              if (
                array[i].LayerData[j].widthOnTimeline +
                  array[i].LayerData[j].startPositionOnTimeline >
                array[i].endBackground
              ) {
                array[i].LayerData[j].widthOnTimeline = Math.abs(
                  array[i].LayerData[j].startPositionOnTimeline -
                    array[i].endBackground
                );
              }
            }

            if (OnePx) array[i].LayerData[j].OnePx = OnePx;
            array[i].LayerData[j].EditorZoom = EditorZoom;
            array[i].LayerData[j].StartFrame = parseInt(
              ((totalTimeToMs(array[i].LayerData[j].startTime) + time) / 1000) *
                CallForExport.fps
            );

            array[i].LayerData[j].time = time;

            // if (array[i].LayerData[j].LastStartPositionOnTimeline) {
            //   array[i].LayerData[j].LastStartPositionOnTimeline =
            //     array[i].startBackground +
            //     array[i].LayerData[j].LastStartPositionOnTimeline;

            //   if (
            //     array[i].LayerData[j].widthOnTimeline + array[i].LayerData[j].LastStartPositionOnTimeline > array[i].endBackground ) {
            //     array[i].LayerData[j].widthOnTimeline = Math.abs( array[i].LayerData[j].LastStartPositionOnTimeline - array[i].endBackground);
            //   }
            // } else {
            //   if (
            //     array[i].LayerData[j].widthOnTimeline +
            //       array[i].LayerData[j].startPositionOnTimeline >
            //     array[i].endBackground
            //   ) {
            //     array[i].LayerData[j].widthOnTimeline = Math.abs(
            //       array[i].LayerData[j].startPositionOnTimeline -
            //         array[i].endBackground
            //     );
            //   }
            // }

            let startTransPerc =
              array[i].LayerData[j].startTransitionWidth /
              array[i].LayerData[j].widthOnTimeline;
            let endTransPerc =
              array[i].LayerData[j].endTransitionWidth /
              array[i].LayerData[j].widthOnTimeline;

            // array[i].LayerData[j].startTransitionWidth =
            //   array[i].startBackground +
            //   array[i].LayerData[j].startTransitionWidth;

            array[i].LayerData[j].endTransitionWidth =
              array[i].startBackground +
              array[i].LayerData[j].endTransitionWidth;

            array[i].LayerData[j].endTransitionLeft =
              array[i].LayerData[j].widthOnTimeline -
              array[i].LayerData[j].endTransitionWidth;

            array[i].LayerData[j].InClass = "";
            array[i].LayerData[j].OutClass = "";

            array[i].Editable = false;
            array[i].FurtherSetting = false;
            array[i].LayerData[j].SlideLength = array[i].TotalLength;
            array[i].LayerData[j].SlideNo = i;

            var diff = array[i].LayerData[j].endTime;

            var tlength = totalTimeToMs(
              calculateTimeByWidth(
                slides.filter((x) => x.IsActive == true)[0].TotalSlideWidth
              )
            );
            var dif = totalTimeToMs(diff);

            if (array[i].LayerData[j].type == "audio") {
              // if (array[i].LayerData[j].Name === "audio-3") {
              //   debugger;
              // }
              tlength = totalTimeToMs(array[i].LayerData[j].SlideLength);
              if (dif > tlength) {
                var diff2 = dif - tlength;
                array[i].LayerData[j].endSound = convertSecondtoTimeString(
                  (dif - diff2) / 1000
                );
                //array[i].endSound = array[i].endSound - array[i].startTime  + array[i].startSound
              } else {
                array[i].LayerData[j].endSound = diff;
              }
            }

            if (
              array[i].LayerData[j].type === "audio" &&
              array[i].LayerData[j].startSound
            ) {
              array[i].LayerData[j].startSoundInSeconds = calculateTimeByWidth(
                array[i].LayerData[j].startSound
              );
            }
            slideData.push(array[i].LayerData[j]);
          }
        }

        time += totalTimeToMs(array[i].TotalLength);
      }

      if (localStorage.getItem("onePxEquivalent")) {
        OnePx = localStorage.getItem("onePxEquivalent");
      }

      // Characters, props and animated text need their animation JSON in the export. It can be
      // missing (e.g. after "save slide"), so load it here. (The old code stored an async function
      // instead, which JSON.stringify drops, and the renderer then waited forever.)
      const lottieCache = {};
      for (const item of slideData) {
        if (
          (item.type === "Character" || item.type === "Props" || item.type === "AnimatedText") &&
          !item.JSONValue &&
          item.character_FilePath
        ) {
          const src = /^https?:/i.test(item.character_FilePath)
            ? item.character_FilePath
            : assetUrl(authenticationData.ApiBaseURL, item.character_FilePath);
          try {
            if (!lottieCache[src]) {
              const resp = await fetch(src);
              lottieCache[src] = await resp.json();
            }
            item.JSONValue = JSON.parse(JSON.stringify(lottieCache[src]));
          } catch (e) {
            console.log("Could not load animation for export", item.character_FilePath, e);
          }
        }
      }

      slideData.forEach((item, index) => {
        item.AnimationId = item.AnimationId + "-" + index;
        item.StartAudioTimeTTS = calculateTimeByWidth(item.StartAudioTime);
        if(item.TTSDuration)
          item.endTTSSound = item.TTSDuration;
        //TotalTimeOfAllSlide += calculateDuration(item.TotalLength);
      });

      let canvasHeight, canvasWidth;
      if (CurrentProject.canvasSize == "16:9") {
        canvasWidth = 1920;
        canvasHeight = 1080;
      } else if (CurrentProject.canvasSize == "9:16") {
        canvasWidth = 1080;
        canvasHeight = 1920;
      } else if (CurrentProject.canvasSize == "1:1") {
        canvasWidth = 1080;
        canvasHeight = 1080;
      }

      // Pictures added since the last save are still embedded (they are stored on the server in
      // the background, see Utils/layerImages.js). Send their address instead of the copy; the
      // editor's own layers are updated too, so the next save is small as well.
      try {
        await linkEmbeddedImages(authenticationData.ApiBaseURL, slides, LayersData, slideData);
      } catch (e) {
        console.log("Pictures stay embedded for this export.", e);
      }

      array.forEach((element) => {
        element.LayerData = null;
      });

      let exportObj = {
        // Each distinct animation once (the render worker fills in the rest); see Utils/projectPack.js.
        SlideData: packExportLayers(slideData),
        slides: JSON.stringify(array),
        bgData: JSON.stringify(bgData),
        // Width: 1920,
        // Height: 1080,
        Width: width,
        Height: height,
        canvasHeight: canvasHeight,
        canvasWidth: canvasWidth,
        OnePx: OnePx,
        TotalFrames: parseInt((time / 1000) * CallForExport.fps),
        Fps: CallForExport.fps,
        Tl_TotalTime_Width: slides[slides.length - 1].endBackground,
        bpath: "",
        FileName: "",
        ProjectId: CurrentProject.id,
        ProjectName:  CurrentProject.projectName.toString().replace(/[/\\?.%*:|"<>]/g, '-'),
        watermark: watermark,
        backgroundMusic: bgmusicState,
        format: CallForExport.format === "webm" ? "webm" : "mp4",
      };

      setDeafultLoader({ played: true, stat: true });
      const resetExport = () =>
        setCallForExport({
          status: false,
          fps: 30,
          format: "mp4",
        });
      startExport(authenticationData.ApiBaseURL, exportObj)
        .then((data) => {
          setDeafultLoader({ played: false, stat: false });
          if (data.status) {
            swal(
              "Export started",
              "Your video is being created. You can follow its progress in [My Videos] and keep editing meanwhile.",
              "success"
            );
          } else {
            swal("Export not started", data.error || "Please contact our support team.", "error");
          }
          resetExport();
        })
        .catch((error) => {
          setDeafultLoader({ played: false, stat: false });
          const status = error && error.response && error.response.status;
          swal(
            "Export not started",
            status === 401 || status === 403
              ? "Your session has expired. Please sign in again."
              : "Could not reach the server. Please check your connection and try again.",
            "error"
          );
          resetExport();
          console.log(error);
        });
     } catch (error) {
      console.log("Export could not be prepared", error);
      setDeafultLoader({ played: false, stat: false });
      swal(
        "Export not started",
        "Something in this project could not be prepared for export. Please save the project and try again, or contact support.",
        "error"
      );
      setCallForExport({ status: false, fps: 30, format: "mp4" });
     }
    }
  }, [CallForExport]);

  const calculateDuration = (duration) => {
    var tempArr = duration.split(":");
    var hours = parseInt(tempArr[0]);
    var minutes = parseInt(tempArr[1]);
    var seconds = parseInt(tempArr[2]);
    var milliseconds = parseInt(tempArr[3]);
    var totalMilliseconds =
      (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;
    return Math.round(totalMilliseconds);
  };

  function convertSecondtoTimeString(seconds) {
    var sec_num = parseFloat(seconds);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;
    //debugger;
    if (seconds.toString().includes(".")) {
      var mill = seconds.toString().split(".")[1] * 100;
      seconds = seconds.toString().split(".")[0];
    } else {
      var mill = "000";
    }
    //var milsec = (sec_num % 1)*1000;
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return `${hours}:${minutes}:${seconds}:${mill}`;
    // return [hours,minutes,seconds,milsec]
    //     .map(v => v < 10 ? "0" + v : v)
    //     .filter((v,i) => v !== "00" || i > 0)
    //     .join(":")
  }

  return (
    <>
      <div className="appWrapper">
        {DashPop && (
          <div className="Dashpop" onClick={() => setDashPop(false)}>
            <div className="dashboardBody">
              <Leftbar Editor={true} setDashPop={setDashPop} />
            </div>
          </div>
        )}

        <div className="appInsider">
          {DeafultLoader.stat && (
            <div
              style={{
                width: "100%",
                height: "100%",
                background: "rgb(255 255 255 / 85%)",
                zIndex: "9999999",
                inset: "0px",
                position: "fixed",
              }}
            >
              <div
                ref={AnimationRef}
                style={{
                  width: "300px",
                  height: "300px",
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
              <div
                style={{
                  position: "relative",
                  left: "50%",
                  top: "61%",
                  transform: "translate(-50%, -50%)",
                  display: "inline-block",
                }}
              >
                Processing, Please Wait.
              </div>
            </div>
          )}

          <ProjectContext.Provider
            value={{
              slides,
              changinCanvasSize,
              setchanginCanvasSize,
              setslides,
              projectEditorZoom,
              setprojectEditorZoom,
              CurrentProject,
              setCurrentProject,
              ProjectLoaded,
              setProjectLoaded,
              changes,
              setchanges,
              Clear,
              setClear,
              ChangeCount,
              setChangeCount,
              setDeafultLoader,
              LayersData,
              setLayersData,
              charstate,
              setcharstate,
              SlidesData,
              setSlidesData,
              slide_background_image,
              setSlide_background_image,
              setwatermark,
              watermark,
              setbgmusicState,
              bgmusicState,
            }}
          >
            {slides != undefined && slides != null && (
              <>
                <Navbar
                  setpopupload={setpopupload}
                  setCallForExport={setCallForExport}
                  setPopupWidthHeight={setPopupWidthHeight}
                  setDashPop={setDashPop}
                  LayersData={LayersData}
                  setAdminPanelPopup={setAdminPanelPopup}
                  SlideBackground={SlideBackground}
                  setShowSmartCharaterBuilderPanel={
                    setShowSmartCharaterBuilderPanel
                  }
                  setLinkGenPop={setLinkGenPop}
                />

                <Body
                  AIContentPopup={AIContentPopup}
                  setAIContentPopup={setAIContentPopup}
                />

                {AdminPanelPopup && (
                  <AdminProps
                    AdminPanelPopup={AdminPanelPopup}
                    setAdminPanelPopup={setAdminPanelPopup}
                  />
                )}

                {linkGenPop && (
                  <LinkGenerator
                    linkGenPop={linkGenPop}
                    setLinkGenPop={setLinkGenPop}
                  />
                )}

                {AIContentPopup && (
                  <AIContent
                    article={article}
                    setArticle={setArticle}
                    title={title}
                    setTitle={setTitle}
                    AIContentPopup={AIContentPopup}
                    setAIContentPopup={setAIContentPopup}
                    setisTextInputOrAreaFocus={setisTextInputOrAreaFocus}
                  />
                )}

                {ShowSmartCharaterBuilderPanel && (
                  <DefaultCharacterView
                    setShowSmartCharaterBuilderPanel={
                      setShowSmartCharaterBuilderPanel
                    }
                    ShowSmartCharaterBuilderPanel={
                      ShowSmartCharaterBuilderPanel
                    }
                  />
                )}

                {popupload && (
                  <Preview
                    _unloadedCounter={_unloadedCounter}
                    UnloadedCounter={UnloadedCounter}
                    setUnloadedCounter={setUnloadedCounter}
                    LoadCounter={LoadCounter}
                    setLoadCounter={setLoadCounter}
                    setSupremeLayer={setSupremeLayer}
                    SupremeLayer={SupremeLayer}
                    popupload={popupload}
                    PopupWidthHeight={PopupWidthHeight}
                    setScreenSize={setScreenSize}
                    SlideBackground={SlideBackground}
                    setSlideBackground={setSlideBackground}
                    ScreenSize={ScreenSize}
                    setpopupload={setpopupload}
                    SlideData={SupremeLayer.Layer}
                    SlideTime={SupremeLayer.TotalTime}
                    setLayersData={setLayersData}
                    SlidesData={SlidesData}
                    setSlidesData={setSlidesData}
                    isLoaded={isLoaded}
                    slides={slides}
                    setslides={setslides}
                    EditorZoom={EditorZoom}
                  />
                )}
              </>
            )}
          </ProjectContext.Provider>

          {ExpiryCountdown && (
            <div
              className="nofifier-bg"
              onMouseMove={(event) => {
                setExpiryCountdown(false);

                let authData = JSON.parse(
                  localStorage.getItem("animation_studio_2.0_access_token")
                );
                axios
                  .get(
                    authenticationData.ApiBaseURL + "/api/Account/RefreshToken",
                    {
                      headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + authData.access_token,
                      },
                    }
                  )
                  .then((response) => {
                    let userObj = {
                      email: response.data.email,
                      userName: response.data.userName,
                      id: response.data.User_Id,
                    };
                    setUserData(userObj);
                    setAuthenticationData({
                      authenticationData: response.data,
                      ApiBaseURL: apiBaseurl,
                      isAuthenticated: true,
                    });
                    localStorage.setItem(
                      "animation_studio_2.0_access_token",
                      JSON.stringify(response.data)
                    );
                    let expireIn_ms = parseInt(response.data.expires_in);
                    setTimeout(() => {
                      setExpiryCountdown(true);
                    }, expireIn_ms - 20000);
                  })
                  .catch((error) => {
                    setAuthenticationData({
                      authenticateData: authData,
                      ApiBaseURL: apiBaseurl,
                      isAuthenticated: false,
                    });
                  });
              }}
            >
              <div className="logOutCountDowntimerWrapper">
                <span class="material-icons-outlined session-expiry-warning-icon">
                  warning
                </span>
                <label htmlFor="">
                  Your session is going to expire in{" "}
                  <Timer initialMinute={0} initialSeconds={15} />
                  seconds and you will be redirected to login.
                  <span className="TimerText">
                    <br /> Please move your mouse to refresh you session.
                  </span>
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Editor;
